import React from 'react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';

const tooltipStyle = {
    contentStyle: {
        background: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '8px',
        color: '#ffffff',
        fontSize: '13px',
        direction: 'rtl',
    },
};

export default function DayOfWeekHeatmap({ data }) {
    if (!data?.length) return null;

    const max = Math.max(...data.map((d) => d.count), 1);

    return (
        <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
                <XAxis
                    dataKey="day"
                    stroke="#94a3b8"
                    tick={{ fontSize: 11, fill: '#94a3b8', fontFamily: 'Almarai, sans-serif' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    stroke="#94a3b8"
                    tick={{ fontSize: 11, fill: '#94a3b8' }}
                    allowDecimals={false}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    {...tooltipStyle}
                    formatter={(v) => [v, 'احتجاجات']}
                    cursor={{ fill: 'rgba(255,255,255,0.04)' }}
                />
                <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={40}>
                    {data.map((entry, idx) => {
                        const intensity = entry.count / max;
                        return (
                            <Cell
                                key={idx}
                                fill={`rgba(0, 217, 255, ${0.2 + intensity * 0.75})`}
                            />
                        );
                    })}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}
